import { styled } from '@mui/material/styles';
import { Box, Typography, Chip } from '@mui/material';
import { AccessTime, Language } from '@mui/icons-material';

export const TimezoneContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
}));

export const TimezoneContent = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
}));

export const TimezoneRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
}));

export const TimezoneLabel = styled(Typography)(({ theme }) => ({
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
}));

export const VenueChip = styled(Chip)(({ theme }) => ({
    fontSize: '0.75rem',
    height: 20,
    backgroundColor: theme.palette.grey[600],
    color: theme.palette.primary.contrastText,
}));

export const BrowserChip = styled(Chip)(({ theme }) => ({
    fontSize: '0.75rem',
    height: 20,
    backgroundColor: theme.palette.primary.main,
    color: 'white',
}));

export const TimezoneNote = styled(Typography)(({ theme }) => ({
    display: 'block',
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
    lineHeight: 1.2,
}));

export const VenueIcon = styled(AccessTime)(({ theme }) => ({
    fontSize: 16,
    color: 'white',
}));

export const BrowserIcon = styled(Language)(({ theme }) => ({
    fontSize: 16,
    color: theme.palette.text.secondary,
}));
